import React from 'react'
import ClickOutside from 'react-click-outside'
import {Transition} from 'react-transition-group'
import Button from '@components/Button'
import isServerSide from '@helpers/misc/isServerSide'
import useDisableScroll from '@hooks/useDisableScroll'
import useEffect from '@hooks/useEffect'
import useSessionStorageState from '@hooks/useSessionStorageState'
import useState from '@hooks/useState'
import {useRouter} from 'next/router'

import styles from './styles.module.css'

export default function Popup(props) {
  const {
    onlyClosedByButtons,
    keepShowingOnSession,
    principalButtonText,
    closeButtonText,
    principalUrlRedirect,
    closeUrlRedirect,
    content,
    id
  } = props
  const [show, setShow] = useState(false)
  const [exited, setExited] = useState(false)
  const [popup, setPopup] = useSessionStorageState(id)
  const router = useRouter()
  const onClose = url => {
    if (url) {
      if (url.startsWith('/')) {
        router.replace(url)
      } else {
        window.location.href = url
      }
    } else {
      setShow(false)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, 100)

    if (popup && !keepShowingOnSession) {
      setTimeout(() => {
        setShow(false)
      }, 150)
    } else {
      setPopup('true')
    }
  }, [])

  useDisableScroll(show)

  if (exited || isServerSide()) return null

  return (
    <Transition in={show} timeout={500} appear onExited={() => setExited(true)}>
      {state => (
        <div className={styles['container_' + state]}>
          <ClickOutside onClickOutside={() => (onlyClosedByButtons ? null : setShow(false))}>
            <div className={styles['content_' + state]}>
              <div className={styles.popupContentWrapper}>
                <div className={styles.popupContent} dangerouslySetInnerHTML={{__html: content}} />
                {principalButtonText ? (
                  <Button primary onClick={() => onClose(principalUrlRedirect)}>
                    {principalButtonText}
                  </Button>
                ) : null}
                {closeButtonText ? (
                  <Button secondary onClick={() => onClose(closeUrlRedirect)}>
                    {closeButtonText}
                  </Button>
                ) : null}
              </div>
            </div>
          </ClickOutside>
        </div>
      )}
    </Transition>
  )
}
